import { Component, computed, signal } from '@angular/core';
import { ModulesRepoService } from '../modules-repo.service';
import { KopConfigService } from '../../core/kop-config.service';
import { AfdModuleMeta, AfdSlotMeta } from '@etron/typings';
import { TreeItemDragStartEvent } from '@progress/kendo-angular-treeview';
import { KopModulesService } from '../kop-modules.service';
import { JSBridgeService } from '../../core/jsbridge.service';
import { defaultIfEmpty } from 'rxjs';

type TreeNode = {
  id: string;
  parentId?: string;
  label: string;
  icon?: string;
  defaultIcon: string;
  isUsed: boolean;
  isDraggable: boolean;
  data: any;
  children?: TreeNode[]
}

@Component({
  selector: 'module-bar',
  templateUrl: './module-bar.component.html',
  styleUrl: './module-bar.component.scss'
})
export class ModuleBarComponent {

  constructor(public moduleRepo: ModulesRepoService, public kopConfigService: KopConfigService, 
    public jsBridgeService: JSBridgeService,
    private modulesService: KopModulesService) { }


  public modules = computed(() => {
    let type = this.kopConfigService.selectedAfd()?.afdeling()?.type;
    if (type == undefined) return [];
    return this.moduleRepo.getModules(type);
  });

  public slots = computed(() => {
    let type = this.kopConfigService.selectedAfd()?.afdeling()?.type;
    if (type == undefined) return [];
    return this.moduleRepo.getSlots(type);
  });

  public filter = signal<string>('');

  public filteredSlots = computed(() => {
    let filter = this.filter();
    let slots = this.slots();
    return slots.filter(s => {
      let slotHasName = s.name.toLowerCase().includes(filter.toLowerCase());
      if (slotHasName) return true;
      for (let module of s.modules) {
        let md = this.moduleRepo.getModule(module);
        if (md != undefined) {
          let moduleHasName = md.name.toLowerCase().includes(filter.toLowerCase());
          if (moduleHasName) return true;
        }
      }
      //let moduleHasName = s.modules.find((v) => v.)
      return false;
    });
  });

  private isUsed2(slot: AfdSlotMeta): boolean {
    let usedModules = this.modulesService.afdModules();
    let slotModules = slot.modules || [];
    let idx = usedModules.findIndex(m => slotModules.indexOf(m.meta.key) >= 0);
    console.log(slot.name, idx >= 0);
    return idx >= 0;
  }

  public isNodeDisabled = (obj: object): boolean => {
    let dataItem = obj as TreeNode;
   return dataItem.isUsed;
  };

  public treeNodes = computed(() => {
    let slots = this.slots();
    let ret: TreeNode[] = [];
    let type = this.kopConfigService.selectedAfd()?.afdeling()?.type;
    if (type == undefined) return [];

    let groups = this.moduleRepo.getGroups(type);
    let gm: Record<string, string> = {};
    for (let g of groups) {
      for (let m of g.children) {
        gm[m] = g.key;
      }
    }
    for (let g of groups) {
      ret.push({
        id: g.key,
        label: g.name,
        icon: g.icon,
        defaultIcon: 'icons/group.png',
        isUsed: false,
        data: g,
        isDraggable: false,
        parentId: gm[g.key],
      });

    }
    for (let slot of slots) {
      let isUsed = this.isUsed2(slot);

      if (slot.modules.length == 1) {
        let module = slot.modules[0];
        let md = this.moduleRepo.getModule(module);
        if (md != undefined) {
          let parentId = undefined;
          if (gm[slot.key] != undefined) {
            parentId = gm[slot.key];
          } else if (gm[module] != undefined) {
            parentId = gm[module];
          }
          ret.push({
            id: md.key,
            label: md.name,
            data: md,
            isUsed: isUsed,
            icon: md.icon,
            isDraggable: true,
            defaultIcon: 'icons/module.png',
            parentId: parentId
          });
        }
        
      } else {
        let md1 = this.moduleRepo.getModule(slot.modules[0]);
        ret.push({
          id: slot.key,
          label: slot.name,
          icon: slot.icon,
          isUsed: isUsed,
          data: md1,
          defaultIcon: 'icons/slot.png',
          isDraggable: true,
          parentId: gm[slot.key]
        });
        for (let module of slot.modules) {
          let md = this.moduleRepo.getModule(module);
          if (md != undefined) {
            ret.push({
              id: md.key,
              label: md.name,
              parentId: slot.key,
              icon: md.icon,
              isUsed: isUsed,
              defaultIcon: 'icons/module.png',
              isDraggable: true,
              data: md
            });
          }
        }
      }
    }
    ret.sort((a, b) => a.label.localeCompare(b.label));
    return ret;
  });

  onDragStart2($event: TreeItemDragStartEvent) {
    console.log($event);
  }

  onDragStart($event: DragEvent, module: AfdModuleMeta) {
    console.log($event, module);
    if ($event.dataTransfer != null) {
      $event.dataTransfer.setData('module', module.key);
    }
  }

}
